import Isotope from 'isotope-layout';
const $win = $(window)

$win.on('load', function() {
  if ($('.js-grid').length && $('.js-grid-item').length) {
    const grid = new Isotope('.js-grid', {
      itemSelector: '.js-grid-item'
    });
  }
})
